import theme from "../../../theme";
import {SxStyles} from "../../../types";

export const buttonStyles: SxStyles = {
    button: {
        py: 1.5,
        px: 2,
        height: 46,
        fontSize: '1.97vmin',
        lineHeight: '22px',
        textTransform: 'none',
        borderRadius: theme.palette?.propVars?.borderRadius,
        fontWeight: theme.palette?.propVars?.semiBoldFontWeight,
        backgroundSize: '200%',
        backgroundPosition: ' right bottom',
        boxShadow: 'none',
        '&.Mui-disabled': {
            opacity: 0.5,
        },
        '&:hover': {
            boxShadow: 'none',
        },
        '&.primaryBtn': {
            backgroundImage: `linear-gradient(to left, ${theme.palette?.myPrimary?.lightBlue100} 50%, ${theme.palette?.myPrimary?.darkBlue100} 50%)`,
            color: theme.palette?.myPrimary?.white,
            '&:hover': {
                backgroundPosition: 'left bottom',
            },
            '&:active': {
                boxShadow: 'none',
            },
            '&.Mui-disabled': {
                background: theme.palette?.myPrimary?.lightBlue100,
            },
        },
        '&.secondaryBtn': {
            backgroundImage: `linear-gradient(to left, transparent 50%, ${theme.palette.myPrimary?.lightBlue40} 50%)`,
            border: `1px solid ${theme.palette.myPrimary?.lightBlue100}`,
            color: theme.palette.myPrimary?.lightBlue100,
            '&:hover': {
                backgroundPosition: 'left bottom',
            },
            '&:active': {
                color: theme.palette.myPrimary?.lightBlue100,
            },
            '&.Mui-disabled': {
                backgroundColor: 'transparent',
            },
        },
        '&.inputBtn': {
            backgroundColor: theme.palette.myPrimary?.lightBlue100,
            backgroundImage: `linear-gradient(to left, ${theme.palette.myPrimary?.lightBlue70} 50%, ${theme.palette.myPrimary?.lightBlue100} 50%)`,
            color: theme.palette.myPrimary?.white,
            '&:hover': {
                backgroundPosition: 'left bottom',
            },
            '&.Mui-disabled': {
                background: theme.palette.myPrimary?.lightBlue100,
            },
        },
    },
};


